<ng-container *transloco="let t">
  <div
    class="filter-pill__container"
    [matTooltip]="pillTooltip"
    [matTooltipClass]="'filter-pill__tooltip'"
  >
    <div
      class="filter-pill"
      [ngClass]="{
        'filter-pill--tall': pillTextExtra,
        'filter-pill--normal': !pillTextExtra,
        'filter-pill--parent': isParentFilter,
        'filter-pill--user-search': userSearch,
      }"
    >
      <div class="filter-pill__left-side">
        @if (!userSearch) {
          <div class="filter-pill__short-label">
            <span>{{ shortLabel }}</span>
          </div>
        } @else {
          <xi-icon icon="search" contrast="high"></xi-icon>
        }

        <div
          class="filter-pill__content"
          [ngClass]="{ 'filter-pill__content-user-search': userSearch }"
        >
          <div *appMiddleEllipsize="pillText; hideTooltip: true"></div>

          <div *appMiddleEllipsize="pillTextExtra; hideTooltip: true"></div>
        </div>
      </div>

      <div class="filter-pill__right-side">
        @if (isParentFilter) {
          <xi-icon-button
            fill="no-fill"
            contrast="normal"
            icon="split_filled"
            [active]="false"
            [hasAnimation]="false"
            [tooltip]="{ text: t('lex-xi-filter-pill-component.parent-filter'), direction: 9 }"
          ></xi-icon-button>
        }
        @if (!isPillDisabled) {
          <xi-dropdown
            [data]="dropdown"
            [value]="selectedItems"
            select="single"
            type="icon"
            color="orca"
            [contrast]="userSearch ? 'high' : 'normal'"
            [disabled]="isActionDisabled"
            [tooltip]="actionTooltip ? { text: actionTooltip } : undefined"
            [internalProps]="{ iconButton: { icon: 'settings' } }"
            (onValueChange)="onPillAction($event.detail.selected.id)"
          ></xi-dropdown>
        }
      </div>
    </div>
  </div>

  <div
    #numericMetadataPopover="ngbPopover"
    [ngbPopover]="tNumericMetadataPopover"
    [container]="'body'"
    [autoClose]="false"
    [placement]="'bottom-right'"
    popoverClass="lex-xi-filter-pill__popover"
  ></div>

  @if (filter.analyticItem.includes('createdAt')) {
    <app-filter-date-calendar
      #dateMetadataCalendar
      [field]="filter.analyticItem"
      [filter]="filter"
      [placeholder]="t('lex-xi-filter-pill-component.date-placeholder')"
      (filtersChange)="onFilterDateChange($event)"
    ></app-filter-date-calendar>
  }

  <ng-template #tNumericMetadataPopover>
    <div (mousedown)="$event.stopPropagation()">
      <app-numeric-metadata-popover
        [filter]="filter"
        (valueChange)="onPopoverChange($event)"
      ></app-numeric-metadata-popover>
    </div>
  </ng-template>
</ng-container>
